import { styled, XStack } from 'tamagui';

export const StyledHorizontalScroll = styled(XStack, {
  name: 'StyledHorizontalScroll',
  flexDirection: 'row',
  overflow: 'scroll',
  width: '100%',
  height: 288,
  gap: '$5',
});
